import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import Table from '../../../components/Table/Table';
import TableHead from '../../../components/Table/TableHead';
import TableRow from '../../../components/Table/TableRow';
import TableHeadData from '../../../components/Table/TableHeadData';
import TableBody from '../../../components/Table/TableBody';
import TableData from '../../../components/Table/TableData';
import Checkbox from '../../../components/Checkbox/Checkbox';
import Badge from '../../../components/Badge/Badge';
import ButtonTypes from '../../../constants/buttonTypes';
import Text from '../../../components/Text/Text';
import toggleArrayItem from '../../../helpers/toggleArrayItem';
import { IconPlus, IconTrash } from '../../../assets/icon';
import { MAX_RELATED_ARTICLES_LISTING } from '../../../constants/general';
import Button from '../../../components/Button/Button';
import { toggleRelatedArticleListingModal } from '../../../actions/application/application';
import ArticlesRelatedListingItem from './ArticlesRelatedListingItem';

const containerClassName = 'pt-0';
const tableContainerClassName = 'h-[500px] overflow-auto';
const allCheckBoxClassName = 'pl-0';
const tableActionsClassName = 'flex flex-row justify-end p-[10px]';
const selectedTextClassName = 'mr-[10px]';
const buttonClassName = 'p-[7px]';

const ArticlesRelatedListingsTable = ({ relatedItem, setFieldValue }) => {
  const dispatch = useDispatch();
  const [selectedId, setSelectedId] = useState([]);
  const tableHeader = [
    'info', 'status', 'brand'
  ];
  const onSelectAll = () => {
    if (selectedId?.length === relatedItem.length) {
      setSelectedId([]);
    } else {
      setSelectedId(relatedItem?.map((item) => item?.listing_id));
    }
  };

  const onSelectItem = (id) => setSelectedId(toggleArrayItem(selectedId, id));

  const onDelete = () => {
    const temp = relatedItem?.filter(({ listing_id: id }) => !selectedId.includes(id));
    setFieldValue('relatedItem', temp);
  };

  return (
    <div className={containerClassName}>
      <div className={tableActionsClassName}>
        {!!selectedId?.length && (
          <div className="flex flex-row items-center">
            <Text text={`${selectedId.length} selected`} bold styleContainer={selectedTextClassName} />
            <Button
              icon={<IconTrash />}
              type={ButtonTypes.DANGER}
              containerStyle={buttonClassName}
              onClick={onDelete}
              text="Remove"
            />
          </div>
        )}
        {!selectedId?.length && relatedItem?.length < MAX_RELATED_ARTICLES_LISTING
          && (
            <Button
              icon={<IconPlus />}
              text="Add"
              containerStyle={buttonClassName}
              onClick={() => dispatch(toggleRelatedArticleListingModal())}
            />
          )}
      </div>
      <div className={tableContainerClassName}>
        <Table>
          <TableHead>
            <TableRow bordered>
              <TableHeadData className={allCheckBoxClassName}>
                <Checkbox
                  name="selectAll"
                  onChange={onSelectAll}
                  isActive={selectedId?.length === relatedItem.length}
                />
              </TableHeadData>
              {tableHeader.map((item) => (
                <TableHeadData key={item}>
                  {item}
                </TableHeadData>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {relatedItem?.map((item, index) => (
              <TableRow
                bordered={index + 1 < relatedItem.length}
                key={item?.listing_id}
                dataRow={item?.listing_id}
              >
                <TableData>
                  <Checkbox
                    name={item?.listing_id}
                    onChange={() => onSelectItem(item?.listing_id)}
                    isActive={selectedId?.includes(item?.listing_id)}
                  />
                </TableData>
                <TableData>
                  <ArticlesRelatedListingItem item={item} />
                </TableData>
                <TableData>
                  <div className="d-flex">
                    <Badge text={item?.ebay_status} type={ButtonTypes.SUCCESS} />
                  </div>
                </TableData>
                <TableData>
                  <div className="d-flex">
                    <Badge text={item?.listing_seller_manufacturer} type={ButtonTypes.LIGHT} />
                  </div>
                </TableData>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};

ArticlesRelatedListingsTable.propTypes = {
  relatedItem: PropTypes.arrayOf(PropTypes.shape({})),
  setFieldValue: PropTypes.func
};

ArticlesRelatedListingsTable.defaultProps = {
  relatedItem: [],
  setFieldValue: () => {}
};

export default ArticlesRelatedListingsTable;
